import React from "react";
import "../styles/Footer.css";

const Footer = () => {
    return (
        <footer className="footer">
            <p>© 2025 Dawid Ogrodniczuk. All Rights Reserved.</p>
        </footer>
    );
};

export default Footer;
